import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class SettingsAreasBaseController extends Controller {
  @service router;

  @action
  goToListPage() {
    this.router.transitionTo('settings.areas.list');
  }
}
